/* ================================================================
   PHOTO-UPLOADER.JS - musteri fotograf yukleme

   Mimari
   ------
   Dosya Cloudflare R2'ye Worker uzerinden yuklenir; sepete DOSYA degil
   YUKLENMIS URL'IN KENDISI gider. Bu bilincli bir tercih:
     - Shopify'in native dosya yuklemesi yalnizca <form> gonderiminde calisir.
       "Kendi Kutunu Yap" ise /cart/add.js'e JSON gonderiyor (coklu urun) ve
       JSON ile dosya tasinamaz. URL saklayarak HER IKI akis da desteklenir.
     - 20 MB'lik Shopify sinirina takilmaz.
     - Ayni fotograf birden fazla satirda yeniden kullanilabilir.

   Dogrulama sirasi (once ucuz olan):
     1) MIME tipi      -> aninda
     2) Dosya boyutu   -> aninda
     3) Piksel olcusu  -> createImageBitmap ile, yuklemeden ONCE
     4) Sunucu tarafi  -> Worker ayni kontrolleri tekrar yapar (atlatilamaz)

   Disari acilan API (box-builder gibi baska bilesenler icin):
     el.hkUploader.getValues() -> [{url, name, w, h}]
     el.hkUploader.isValid()   -> bool
     'photos:changed' olayi
================================================================ */
'use strict';

(function () {
  var ACCEPT = ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif'];

  function bytesToMb(b) { return Math.round((b / 1048576) * 10) / 10; }

  function init(root) {
    if (!root || root.__puInit) return;
    root.__puInit = true;

    var endpoint = (root.dataset.endpoint || '').replace(/\/+$/, '');
    var min = parseInt(root.dataset.min, 10) || 0;
    var max = parseInt(root.dataset.max, 10) || 1;
    var minPx = parseInt(root.dataset.minPx, 10) || 0;
    var maxMb = parseFloat(root.dataset.maxMb) || 15;
    var propName = root.dataset.prop || 'Fotograf';

    var input = root.querySelector('[data-pu-input]');
    var drop = root.querySelector('[data-pu-drop]');
    var list = root.querySelector('[data-pu-list]');
    var counter = root.querySelector('[data-pu-counter]');
    var status = root.querySelector('[data-pu-status]');
    var fields = root.querySelector('[data-pu-fields]');

    var photos = []; /* {url, name, w, h, bytes} */

    /* ---------- Durum ---------- */
    function say(msg, kind) {
      if (!status) return;
      status.textContent = msg || '';
      status.className = 'pu__status' + (kind ? ' pu__status--' + kind : '');
    }

    function syncFields() {
      if (!fields) return;
      fields.innerHTML = '';
      photos.forEach(function (p, i) {
        var el = document.createElement('input');
        el.type = 'hidden';
        el.name = 'properties[' + propName + (max > 1 ? ' ' + (i + 1) : '') + ']';
        el.value = p.url;
        fields.appendChild(el);
      });
    }

    function syncUi() {
      if (counter) counter.textContent = photos.length + '/' + max;
      root.classList.toggle('pu--full', photos.length >= max);
      root.classList.toggle('pu--incomplete', photos.length < min);
      if (input) input.disabled = photos.length >= max;
      syncFields();
      root.dispatchEvent(new CustomEvent('photos:changed', {
        bubbles: true,
        detail: { photos: photos.slice(), valid: photos.length >= min }
      }));
    }

    function render() {
      if (!list) return;
      list.innerHTML = photos.map(function (p, i) {
        var warn = (minPx && p.w && Math.min(p.w, p.h) < minPx)
          ? '<span class="pu-thumb__warn" title="Dusuk cozunurluk">!</span>' : '';
        return '<li class="pu-thumb">' +
          '<img src="' + p.url + '" alt="" loading="lazy" decoding="async">' +
          '<span class="pu-thumb__no">' + (i + 1) + '</span>' + warn +
          '<button type="button" class="pu-thumb__x" data-pu-remove="' + i + '"' +
          ' aria-label="' + (i + 1) + '. fotografi kaldir">&times;</button>' +
          '</li>';
      }).join('');
      syncUi();
    }

    /* ---------- Olcu okuma ---------- */
    function readSize(file) {
      if (!window.createImageBitmap) return Promise.resolve(null);
      return createImageBitmap(file)
        .then(function (bmp) {
          var d = { w: bmp.width, h: bmp.height };
          bmp.close && bmp.close();
          return d;
        })
        .catch(function () { return null; }); /* HEIC bazi tarayicilarda okunamaz */
    }

    /* ---------- Yukleme ---------- */
    function upload(file) {
      var fd = new FormData();
      fd.append('file', file);
      return fetch(endpoint + '/upload', { method: 'POST', body: fd })
        .then(function (r) { return r.json().catch(function () { return { ok: false }; }); });
    }

    function handleFiles(fileList) {
      var files = Array.prototype.slice.call(fileList || []);
      if (!files.length) return;

      if (!endpoint) {
        say('Yukleme servisi yapilandirilmamis. Lutfen bizimle iletisime gecin.', 'error');
        return;
      }

      var room = max - photos.length;
      if (room <= 0) { say('Bu urun icin en fazla ' + max + ' fotograf ekleyebilirsiniz.', 'error'); return; }
      if (files.length > room) {
        say('Yalnizca ' + room + ' fotograf daha ekleyebilirsiniz; fazlasi atlandi.', 'warn');
        files = files.slice(0, room);
      }

      root.classList.add('pu--busy');
      var done = 0, failed = 0;

      var chain = files.reduce(function (prev, file) {
        return prev.then(function () {
          /* 1) tip */
          if (ACCEPT.indexOf(file.type) === -1) {
            failed++; say(file.name + ': yalnizca JPG, PNG, WEBP veya HEIC yuklenebilir.', 'error');
            return;
          }
          /* 2) boyut */
          if (file.size > maxMb * 1048576) {
            failed++; say(file.name + ': dosya cok buyuk (' + bytesToMb(file.size) + ' MB, sinir ' + maxMb + ' MB).', 'error');
            return;
          }
          say('Yukleniyor... (' + (done + 1) + '/' + files.length + ')');

          /* 3) olcu + 4) yukleme */
          return readSize(file).then(function (dim) {
            return upload(file).then(function (res) {
              if (!res || !res.ok) {
                failed++;
                say(res && res.message ? res.message : 'Fotograf yuklenemedi, tekrar deneyin.', 'error');
                return;
              }
              photos.push({
                url: res.url, name: file.name, bytes: res.bytes,
                w: dim ? dim.w : 0, h: dim ? dim.h : 0
              });
              done++;
              render();
            });
          });
        });
      }, Promise.resolve());

      chain.then(function () {
        root.classList.remove('pu--busy');
        if (input) input.value = '';
        if (!failed) {
          var low = photos.filter(function (p) { return minPx && p.w && Math.min(p.w, p.h) < minPx; });
          if (low.length) {
            say(low.length + ' fotografin cozunurlugu dusuk. Baskida bulanik cikabilir; mumkunse daha buyuk bir dosya secin.', 'warn');
          } else if (done) {
            say(done + ' fotograf eklendi.', 'ok');
            setTimeout(function () { say(''); }, 2500);
          }
        }
      });
    }

    /* ---------- Olaylar ---------- */
    if (input) input.addEventListener('change', function () { handleFiles(input.files); });

    if (drop) {
      ['dragenter', 'dragover'].forEach(function (ev) {
        drop.addEventListener(ev, function (e) {
          e.preventDefault(); drop.classList.add('is-over');
        });
      });
      ['dragleave', 'drop'].forEach(function (ev) {
        drop.addEventListener(ev, function (e) {
          e.preventDefault(); drop.classList.remove('is-over');
        });
      });
      drop.addEventListener('drop', function (e) {
        handleFiles(e.dataTransfer && e.dataTransfer.files);
      });
    }

    root.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-pu-remove]');
      if (!rm) return;
      photos.splice(parseInt(rm.dataset.puRemove, 10), 1);
      render();
      say('');
    });

    /* ---------- Sepete ekleme kilidi ---------- */
    var form = root.closest('form[action*="/cart/add"]');
    if (form && min > 0) {
      form.addEventListener('submit', function (e) {
        if (photos.length >= min) return;
        e.preventDefault();
        e.stopPropagation();
        say('Devam etmek icin en az ' + min + ' fotograf eklemelisiniz.', 'error');
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, true);
    }

    /* ---------- Disari acilan API ---------- */
    root.hkUploader = {
      getValues: function () { return photos.slice(); },
      isValid: function () { return photos.length >= min; },
      clear: function () { photos = []; render(); }
    };

    render();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-photo-uploader]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
